import { useCallback, useRef } from "react";

/**
 * Recreate the card spotlight hover gradient from the source site.
 * Translation: Recreate the card spotlight hover gradient from the source site.
 *
 * @returns {Object} Spotlight ref and mouse handlers.
 */
const useSpotlight = () => {
  const cardRef = useRef(null);

  const frameRef = useRef(null);

  /**
   * Update local CSS variables from pointer movement.
   * Translation: Update local CSS variables from pointer movement.
   *
   * @param {React.MouseEvent<HTMLElement>} event - Pointer event.
   */
  const handleMouseMove = useCallback((event) => {
    if (!cardRef.current) {
      return;
    }

    if (frameRef.current) {
      cancelAnimationFrame(frameRef.current);
    }

    const { left, top } = cardRef.current.getBoundingClientRect();
    const localX = event.clientX - left;
    const localY = event.clientY - top;

    frameRef.current = requestAnimationFrame(() => {
      if (cardRef.current) {
        cardRef.current.style.setProperty("--spotlight-x", `${localX}px`);
        cardRef.current.style.setProperty("--spotlight-y", `${localY}px`);
      }
    });
  }, []);

  /**
   * Reset spotlight positioning when the pointer exits.
   * Translation: Reset spotlight positioning when the pointer exits.
   */
  const handleMouseLeave = useCallback(() => {
    if (!cardRef.current) {
      return;
    }

    cardRef.current.style.removeProperty("--spotlight-x");
    cardRef.current.style.removeProperty("--spotlight-y");
  }, []);

  return {
    cardRef,
    handleMouseMove,
    handleMouseLeave,
  };
};

export default useSpotlight;
